export default {
  successText: 'הפעולה הצליחה',
  submitText: 'אישור'
};
